export default __webpack_public_path__ + "static/media/726.ffa6fdf9.gif";